import React from 'react';
import { LineChart, ResponsiveContainer, Line, XAxis, YAxis } from 'recharts';

import { Box, Grid, Typography } from '@mui/material';
import { makeStyles, Theme } from '@material-ui/core/styles';

import { RearViewKeyMetricsPropTypes } from 'src/interfaces/iproptypes';
import DisabledBlurCard from 'src/App/Pages/EstimatorPage/UtilityComponents/BlurCard';
import { LoadingCard } from '../..';
import { COLOR_ERROR_1, COLOR_PRIMARY_1 } from 'src/colors';

const useStyles = makeStyles((theme: Theme) => ({
  cardRoot: {
    background: '#fff',
  },
}));

const RearViewKeyMetrics = ({
  title,
  graphData,
  color,
  isDisabled,
  unit,
  percentile,
  timePeriod,
  onDisabledOptionClick,
  isLoading,
  isFailed,
}: RearViewKeyMetricsPropTypes) => {
  const classes = useStyles();
  let blurGraph = {};

  return (
    <Grid
      container
      direction="column"
      justifyContent="space-between"
      item
      xs={12}
      className={classes.cardRoot}
    >
      <Grid container direction="row" justifyContent="space-between" alignItems="center">
        {timePeriod && (
          <Typography variant="h2" sx={{ fontWeight: 500 }}>
            {title}
          </Typography>
        )}
      </Grid>

      <Grid container direction="row" justifyContent="flex-start" spacing={0}>
        <Grid
          container
          item
          xs={12}
          direction="row"
          style={{ position: 'relative', top: '0', left: '0' }}
        >
          {isLoading ? (
            <Grid item xs={12} sx={{ mt: 2 }}>
              <LoadingCard height={200} type="bars" />
            </Grid>
          ) : isFailed ? (
            <Grid item xs={12} sx={{ mt: 2 }}>
              <Box
                sx={{
                  background: COLOR_ERROR_1,
                  padding: '5px 10px',
                  backdropFilter: 'blur(4px)',
                  overflow: 'hidden',
                  height: 'auto',
                  borderRadius: 4,
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Typography variant="body2" style={{ color: '#fff' }}>
                  Failed to fetch revenue seasonality. Please recreate the report.
                </Typography>
              </Box>
            </Grid>
          ) : (
            <Grid
              item
              xs={12}
              style={
                isDisabled
                  ? {
                      filter: 'blur(3px)',
                    }
                  : {}
              }
            >
              <ResponsiveContainer height={200} width="100%">
                <LineChart
                  data={graphData}
                  style={blurGraph}
                  margin={{ top: 10, right: 10, bottom: 10, left: 30 }}
                >
                  <Line
                    animationDuration={150}
                    isAnimationActive={false}
                    type="monotone"
                    dataKey={percentile}
                    stroke={color}
                    strokeWidth={3}
                    unit={unit}
                  />
                  <XAxis
                    dataKey="timePeriod"
                    tickLine={true}
                    textAnchor="middle"
                    style={{
                      fontSize: '0.75rem',
                      fontFamily: 'Roboto',
                    }}
                  />
                  <YAxis
                    dataKey={percentile}
                    hide={true}
                    style={{
                      fontSize: '0.75rem',
                      fontFamily: 'Roboto',
                    }}
                  />
                </LineChart>
              </ResponsiveContainer>
            </Grid>
          )}

          {isDisabled && (
            <DisabledBlurCard
              subscriptionType="Expert"
              onDisabledOptionClick={onDisabledOptionClick}
            />
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default RearViewKeyMetrics;
